import { Component, ComponentInterface } from '@stencil/core';

@Component({
  tag: 'wb-stage-media',
  styleUrl: 'stage-media.scss',
  shadow: false,
})
export class StageMediaComponent implements ComponentInterface {}
